import type { CSSProperties, ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  title?: string;
  subtitle?: ReactNode;
  /** End-aligned header actions. */
  actions?: ReactNode;
  /** Body touches the card edges (tables). */
  flush?: boolean;
  /** Field Support extension: a slot after the body (e.g. Pagination). */
  footer?: ReactNode;
  style?: CSSProperties;
}

/** The product's one content container. */
export function Card({ children, title, subtitle, actions, flush = false, footer, style }: CardProps) {
  const classes = ['fs-card'];
  if (flush) classes.push('fs-card--flush');
  return (
    <section className={classes.join(' ')} style={style}>
      {(title || actions) && (
        <header className="fs-card__header">
          <div>
            {title && <h2 className="fs-card__title">{title}</h2>}
            {subtitle && <p className="fs-card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="fs-card__actions">{actions}</div>}
        </header>
      )}
      <div className="fs-card__body">{children}</div>
      {footer && <footer className="fs-card__footer">{footer}</footer>}
    </section>
  );
}
